import { useEffect, useRef, useState } from 'react';
import { sessionStorageWrapper } from '@/utils/browser-state';
import { localStorageKey, queryStringKey, setVisionFilter, VisionFilters } from '.';
import styles from './SettingsPanel.module.scss';

export default function SettingsPanel() {
  const [ selectedFilter, setFilter ] = useState<VisionFilters>();
  const filterSelectorRef = useRef<HTMLDivElement|null>(null);

  useEffect(() => {
    setFilter(sessionStorageWrapper.get(localStorageKey) || VisionFilters.noFilter);
  }, []);

  const onFilterSelected = (target: EventTarget, filter: VisionFilters) => {
    if (filterSelectorRef?.current) {
      filterSelectorRef.current.querySelector(`.${styles.selected}`)?.classList.remove(styles.selected);
    }

    (target as HTMLElement).classList.add(styles.selected);

    setFilter(filter);
    setVisionFilter(filter);

    // Provide users with a deeplink url
    window.history.replaceState(null, '', `?${queryStringKey}=${filter}`);
  };

  const FilterSelection = ({ type, label }: {
    type: VisionFilters,
    label: string,
  }) => {
    let className = `${styles.selectable} ${type}`;

    if (selectedFilter === type) {
      className = className + ` ${styles.selected}`;
    }

    return <dd
      className={className}
      onClick={(e) => onFilterSelected(e.target, type)}
    ><span className={styles.filterName}>{type.replaceAll('-', ' ')}</span> {label}</dd>;
  };

  return <div ref={filterSelectorRef}>
    <dt>Color Filters</dt>
    <FilterSelection type={VisionFilters.noFilter} label='No Filter'/>
    <FilterSelection type={VisionFilters.protanopia} label='(no red)'/>
    <FilterSelection type={VisionFilters.deuteranopia} label='(no green)'/>
    <FilterSelection type={VisionFilters.tritanopia} label='(no blue)'/>
    <FilterSelection type={VisionFilters.achromatopsia} label='(no color)'/>
    <FilterSelection type={VisionFilters.blurred} label=''/>
    <FilterSelection type={VisionFilters.lowContrast} label=''/>
  </div>;
}
